import { useMemo } from 'react';
import { useThree } from '@react-three/fiber';
import { SparkRenderer } from './SparkRenderer';
import { SplatMesh } from './SplatMesh';
import { useMotionStore } from '../motion/useMotionStore';
import type { SplatMesh as SparkSplatMesh } from '@sparkjsdev/spark';

interface SparkSplatProps {
  meshRef?: React.Ref<SparkSplatMesh>;
}

/**
 * Consolidated Spark renderer component that handles all Spark.js-specific rendering.
 * This component can be easily swapped out for other splat rendering libraries.
 */
export const SparkSplat = ({ meshRef }: SparkSplatProps) => {
  const renderer = useThree((state) => state.gl);
  const { modelUrl } = useMotionStore();

  // Memoize SparkRenderer args
  const sparkRendererArgs = useMemo(() => {
    return { renderer };
  }, [renderer]);

  // Memoize SplatMesh args
  const splatMeshArgs = useMemo(
    () =>
      ({
        url: modelUrl,
      }) as const,
    [modelUrl],
  );

  return (
    <SparkRenderer args={[sparkRendererArgs]}>
      {/* This particular splat mesh is upside down */}
      <group rotation={[Math.PI, Math.PI * 0.5, 0]} key={modelUrl}>
        <SplatMesh ref={meshRef} args={[splatMeshArgs]} />
      </group>
    </SparkRenderer>
  );
};

